import React from 'react';
import PropTypes from 'prop-types';
import SubOrganizationNode from './SubOrganizationNode';
import SiteNode from './SiteNode';
import { map } from 'lodash';

const OrganizationNode = ({
    organization,
    depth,
    selectedAsset,
    onSelectAsset,
    leftPanelSize,
    allAssets,
    conditionIndicesView,
    selectionNodeIds,
    selectedAssetSignalCounts
}) => {
    return (
        <>
            {map(organization?.subOrganizations, subOrg =>
                <SubOrganizationNode
                    key={subOrg?.organizationId}
                    organization={subOrg}
                    depth={depth + 1}
                    selectedAsset={selectedAsset}
                    onSelectAsset={onSelectAsset}
                    leftPanelSize={leftPanelSize}
                    allAssets={allAssets}
                    conditionIndicesView={conditionIndicesView}
                    selectionNodeIds={selectionNodeIds}
                    selectedAssetSignalCounts={selectedAssetSignalCounts}
                />
            )}
            {map(organization?.sites, site =>
                <SiteNode
                    key={site?.siteId}
                    site={site}
                    depth={depth + 1}
                    selectedAsset={selectedAsset}
                    onSelectAsset={onSelectAsset}
                    leftPanelSize={leftPanelSize}
                    allAssets={allAssets}
                    conditionIndicesView={conditionIndicesView}
                    selectionNodeIds={selectionNodeIds}
                    selectedAssetSignalCounts={selectedAssetSignalCounts}
                />
            )}
        </>
    );
};

OrganizationNode.propTypes = {
    organization: PropTypes.object.isRequired,
    depth: PropTypes.number.isRequired,
    selectedAsset: PropTypes.object,
    onSelectAsset: PropTypes.func,
    leftPanelSize: PropTypes.number,
    showThreshold: PropTypes.bool,
    showTrend: PropTypes.bool,
    conditionIndicesView: PropTypes.string,
    selectionNodeIds: PropTypes.instanceOf(Set),
    selectedAssetSignalCounts: PropTypes.object
};

export default OrganizationNode;
